import classes from "../ServicesTable.module.scss"
import React, { forwardRef, Fragment, useContext, useEffect, useImperativeHandle, useLayoutEffect, useRef, useState } from "react";
import { OrgIdContext } from "../../../store/orgId_context";
import { DDD, E2Data } from "../../../lib/ddd/ddd";
import { useTranslation } from "react-i18next";
import { useQuery } from "@tanstack/react-query";
import WorkflowTextInput from "./WorkflowTextInput";

const apiRequestAddress = process.env.REACT_APP_API_ENDPOINT || window.location.origin + "/json.rpc";
const ddd = new E2Data("EU_AOrg_ServicesEndpoints");
const dddevice = new E2Data("VP_DevicesOrgUnits");
dddevice.format = "full";
const _ddd = new DDD(apiRequestAddress);

const e2stepData = new E2Data("EU_AOrg_ServicesEndpoints");
e2stepData.format = "full";
e2stepData.filter = "ServiceEndPointCode__Step = '40'";

const ServicesFormWorkflows = forwardRef(({deviceId, refetch, orgData, instructions, reloadDataForce, importedData}, ref) => {
    const [device, setDevice] = useState(undefined);
    const [data, setData] = useState();
    const [stepData, setStepData] = useState();
    const { isMaintainer, sessionInfo } = useContext(OrgIdContext);
    const fieldsRef = useRef({});

    const {t} = useTranslation();

    /* const {isPending:stepPending, data:stepData} = useQuery({
        queryKey: ['Data.GetEntityData', e2stepData.GetParamsObject()],
        queryFn: () => e2stepData.GetData()
    }) */
//#region field helpers
    useEffect(() => {
        const e2stepData = new E2Data("EU_AOrg_ServicesEndpoints");
        e2stepData.format = "full";
        e2stepData.filter = `ServiceEndPointCode__Step = '${importedData?.ServiceEndPointCode__Step}' AND ServiceEndPointCode__Direction = '${importedData?.ServiceEndPointCode__Direction}'`;
        e2stepData.GetData().then(res => {
            setStepData(res);
        });
    }, [importedData]);
    useEffect(() => {
        if(device === deviceId) return;
        setDevice(deviceId)
        reloadDeviceData(deviceId);
    }, [deviceId, device]);

    useEffect(() => {
        if(!device) return;
        reloadDeviceData(device);
    }, [refetch]);

    useEffect(() => {
        if(!instructions || Object.keys(fieldsRef?.current) > 0) return;
        Object.keys(instructions).forEach(key => {
            fieldsRef.current[key] = React.createRef();
        });
    }, [instructions]);

    const reloadDeviceData = (id) =>{
        dddevice.filter = `Id="${id}"`;
        dddevice.GetData().then(res => {console.log(res);
            setData(res?.result?.data?.[0])
        });
        const e2stepData = new E2Data("EU_AOrg_ServicesEndpoints");
        e2stepData.format = "full";
        e2stepData.filter = `ServiceEndPointCode__Step = '${importedData?.ServiceEndPointCode__Step}' AND ServiceEndPointCode__Direction = '${importedData?.ServiceEndPointCode__Direction}'`;
        e2stepData.GetData().then(res => {
            setStepData(res);
        });
    }

    const onBeforeSave = async (newData) => {
        let errors = [];
        let res;
        for (const key of Object.keys(fieldsRef?.current)) {
            const ref = fieldsRef.current[key];
            if (ref?.current){
                res = await ref?.current?.onBeforeSave(newData);
                if(hasErrors(res)) errors.push(hasErrors(res));
            }
        }

        if(errors.length > 0) return errors;
        return true;
    }
    const onAfterSave = async (newData) => {
        let res = null;
        let errors = [];
        for (const key of Object.keys(fieldsRef?.current)) {
            const ref = fieldsRef.current[key];
            if (ref?.current){
                res = await ref?.current?.onAfterSave(newData);
                console.log(res);
                if(hasErrors(res)) errors.push(hasErrors(res));
            }
        }

        if(errors.length > 0) return errors;
        return true;
    }

    const _forceReloadData = () => {
        if(reloadDataForce) reloadDataForce();
        reloadDeviceData(device);
    }

    const hasErrors = (res) => {
        if(!Array.isArray(res)) return false;
        return res?.find(e => e?.error);
    };

    useImperativeHandle(ref, () => ({
        onBeforeSave,
        onAfterSave
    }), [deviceId, refetch, orgData, data, stepData]);

    return (
        <>
        <div className={`d-flex classes["formContainer2"]`} style={{padding:"0px", gap: "1rem"}}>
            {instructions && Object.keys(instructions).map((key, index) => {
                const field = instructions[key];
                return <WorkflowTextInput key={key} ref={fieldsRef?.current[key]} deviceData={data} orgData={orgData} stepData={stepData?.result?.data?.[0]} fieldName={key} instructions={field} reloadDataForce={_forceReloadData}/>
            })}
        </div>
        </>
    )
})

export default ServicesFormWorkflows;


const FiscDeviceRegCode ={
    "required": false,
    "label" : "Device registration code",
    "editable": true,
    "instructions": null,
    "instructionsText": "For each cash register/device, it is necessary to input/assign a unique code at the level of the taxpayer.",
    "workflows" : [{"execute" : {"method" : "Data.Modify", "params" : {"entity" : "VP_DevicesOrgUnits", "filter":"Id='<!--device.Id-->'", "values" : {"FiscDeviceRegCode" : "<!--value-->"}}}}],
}
